import { createAction, createActionGroup, emptyProps, props } from '@ngrx/store';
import { ApplicantDto } from '@shared/models/applicant-dto';
import { ApplicantDeletionScenarios } from '@shared/enums/applicant-deletion-scenarios.enum';

export const login = createAction(
    '[Auth] Login',
    props<{ redirectToEuLogin: boolean }>()
);

export const authStatusApiActions = createActionGroup({
    source: 'Auth Status API',
    events: {
        authStatusSuccess: emptyProps(),
        authStatusFailure: props<{ redirectToEuLogin: boolean }>()
    }
});

export const loginApiActions = createActionGroup({
    source: 'Auth API',
    events: {
        loginSuccess: props<{ applicant: ApplicantDto }>(),
        loginFailure: props<{ error }>()
    }
});

export const createProfile = createAction(
    '[Auth] Create profile'
);

export const updateProfile = createAction(
    '[Auth] Update profile',
    props<{ applicant: ApplicantDto }>()
);

export const updateProfileApiActions = createActionGroup({
    source: 'Update profile API',
    events: {
        updateProfileSuccess: props<{ applicant: ApplicantDto }>()
    }
});

export const deleteProfileStatus = createAction(
    '[Auth] Delete profile status'
);

export const deleteProfileStatusApiActions = createActionGroup({
    source: 'Delete profile status API',
    events: {
        deleteProfileStatusSuccess: props<{ applicantDeletionScenarios: ApplicantDeletionScenarios }>()
    }
});

export const deleteProfile = createAction(
    '[Auth] Delete profile'
);

export const deleteProfileApiActions = createActionGroup({
    source: 'Delete profile API',
    events: {
        deleteProfileSuccess: emptyProps()
    }
});

export const logout = createAction(
    '[Auth] Logout'
);

